import React from "react"

export const Twitter = props => (
  <svg width={22} height={18} {...props}>
    <path
      d="M19.761 5.07c0-.196-.004-.392-.013-.587A9.23 9.23 0 0 0 22 2.13a9 9 0 0 1-2.593.715A4.558 4.558 0 0 0 21.393.332c-.873.52-1.839.9-2.867 1.103A4.494 4.494 0 0 0 15.232 0c-2.493 0-4.515 2.034-4.515 4.543 0 .356.04.703.117 1.036-3.75-.19-7.076-2-9.303-4.748A4.55 4.55 0 0 0 .92 3.115c0 1.577.797 2.968 2.008 3.782A4.44 4.44 0 0 1 .885 6.33l-.001.058c0 2.201 1.555 4.037 3.62 4.455a4.52 4.52 0 0 1-2.038.077 4.523 4.523 0 0 0 4.217 3.156A9.02 9.02 0 0 1 0 15.958 12.71 12.71 0 0 0 6.919 18C15.22 18 19.76 11.076 19.76 5.07z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)
